export const getTestingAttributes = (name: string) => ({
  'data-e2e': name,
});
